import React from 'react'
import { Outlet } from 'react-router-dom'

const AuthPage = () => {
  return (
    <Outlet />
  )
}

export default AuthPage